import useGet from "../../hooks/useGet";
import Table from "../../components/table";
import columns from "./column";
import useTable from "../../hooks/useTable";
import CardContainer from "../../components/card_container";
import {
  ADDFABRIC,
  DETAILFABRIC,
  EDITFABRIC,
  GENERATEQR,
} from "../../routes/routes_name";
import CustomModal from "../../components/custom_modal";
import { useState } from "react";
// import DetailFabricPage from "./detail";

const TemplatQrPage = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    filter,
    isLoading,
    data,
    error,
    totalPages,
    handlePagination,
    handleLimit,
    handleFilter,
  } = useGet("/v1/fabric");

  const {
    isLoading: isLoadingPost,
    dataRemove,
    handleEdit,
    handleGenerateQr,
    handleSelected,
    handleRemove,
  } = useTable();

  //   const openModal = () => {
  //     setModalIsOpen(true);
  //   };

  //   const closeModal = () => {
  //     setModalIsOpen(false);
  //   };

  return (
    <>
      <CardContainer
        title="List Template QR"
        isHeader={true}
        // addShow={dataRemove.length < 1}
        // qrShow={dataRemove.length === 1}
        // editShow={dataRemove.length === 1}
        // detailShow={dataRemove.length === 1}
        // deleteShow={dataRemove.length >= 1}
        // addClick={ADDFABRIC}
        searchPlaceholder="Search Template"
        // editClick={() => handleEdit(EDITFABRIC)}
        // detailClick={() => openModal()}
        // qrClick={() => handleGenerateQr(GENERATEQR)}
        // deleteClick={() =>
        //   handleRemove({
        //     url: "/v1/fabric",
        //     descSuccess: "Fabric data has been successfully deleted.",
        //   })
        // }
        // onSearchChange={handleFilter}
      >
        <div className="expanded-y">
          <div className="table-content">
            {/* <Table
              filter={filter}
              isLoading={isLoading}
              error={error}
              data={data}
              totalPages={totalPages}
              handlePagination={handlePagination}
              handleLimit={() => {}}
              handleChangeSelect={handleSelected}
              columns={columns}
            /> */}
          </div>
        </div>
      </CardContainer>
      {/* <CustomModal
        title={"Detail Fabrics"}
        titleBtnOutline={"Edit"}
        onClikBtnOutline={() => handleEdit(EDITFABRIC)}
        titleBtnInner={"Delete"}
        onClikBtnInner={() =>
          handleRemove({
            url: "/v1/fabric",
            descSuccess: "Fabric data has been successfully deleted.",
          })
        }
        withHeader={true}
        withFooter={true}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <DetailFabricPage data={dataRemove[0]} />
      </CustomModal> */}
    </>
  );
};
export default TemplatQrPage;
